import React from 'react';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {
  TextContainer,
  DisplayText,
  TextStyle,
  Button,
  Pagination,
  Stack,
} from '@shopify/polaris';
import {
  ExpertCard,
  SkeletonExpertCard,
} from 'sections/services-marketplace/experts/components';
import {GetProfilesQueryData} from '../../graphql/GetProfilesQuery.graphql';
import {Service} from 'sections/types';
import {Routes} from 'sections/services-marketplace/experts/utilities';

interface OwnProps {
  profiles?: GetProfilesQueryData.Profiles;
  service: Service;
  loading: boolean;
  onNextPage: VoidFunction;
  onPrevPage: VoidFunction;
  onResetFilters(): void;
}

type CombinedProps = OwnProps & WithI18nProps;

export const SKELETON_COUNT = 10;

function Results({
  profiles,
  service,
  loading,
  onNextPage,
  onPrevPage,
  onResetFilters,
  i18n,
}: CombinedProps) {
  if (loading) {
    return (
      <>
        {[...Array(SKELETON_COUNT).keys()].map(key => (
          <SkeletonExpertCard key={key} />
        ))}
      </>
    );
  }

  if (profiles && profiles.edges && !profiles.edges.length) {
    return (
      <Stack vertical spacing="loose">
        <TextContainer spacing="tight">
          <DisplayText size="large" element="h2">
            {i18n.translate('ExpertIndex.EmptyState.title')}
          </DisplayText>
          <DisplayText size="small" element="p">
            <TextStyle variation="subdued">
              {i18n.translate('ExpertIndex.EmptyState.text')}
            </TextStyle>
          </DisplayText>
        </TextContainer>
        <Button primary onClick={onResetFilters}>
          {i18n.translate('ExpertIndex.EmptyState.buttonLabel')}
        </Button>
      </Stack>
    );
  }

  return (
    <div aria-live="polite">
      {profiles &&
        profiles.edges &&
        profiles.edges.map(edge => {
          if (!edge || !edge.node) return null;
          return (
            <ExpertCard
              key={edge.node.handle}
              businessName={edge.node.businessName}
              profileImage={edge.node.image}
              address={edge.node.address}
              startingPrice={edge.node.startingPrice}
              jobsCompleted={edge.node.serviceMetrics.totalJobsCompleted}
              overallRating={edge.node.serviceMetrics.averageRating}
              totalReviews={edge.node.serviceMetrics.totalReviews}
              link={Routes.profileServiceListingPath(
                edge.node.handle,
                service.handle
              )}
            />
          );
        })}

      {profiles && profiles.edges && profiles.edges.length ? (
        <Pagination
          onPrevious={onPrevPage}
          hasPrevious={profiles.pageInfo.hasPreviousPage}
          hasNext={profiles.pageInfo.hasNextPage}
          onNext={onNextPage}
        />
      ) : null}
    </div>
  );
}

export default withI18n()(Results);
